import React, { useContext, useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import Modal from './modal';
import { UserContext } from '../../App';
import AllForms from './allForms';

const LoginModal = ({ showModal, setShowModal }) => {

  const { auth, user } = useContext(UserContext)
  const navigate = useNavigate()

  useEffect(() => {
    if (auth && user?.verified) {
      setShowModal(false)
    }
  }, [auth, user])
  
  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [showModal]);

  return (
    <Modal open={showModal} onClose={() => setShowModal(false)}>
      {showModal ?
        <AllForms />
      :
        ""}
    </Modal>
  )
}

export default LoginModal
